import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function formatUtcTimestamp(iso: string | undefined): string {
  if (!iso) {
    return "";
  }
  const parsed = dayjs(iso).utc();
  return parsed.isValid() ? parsed.format("YYYY-MM-DD HH:mm") : iso;
}

function localTimeZoneAbbreviation(date: Date): string {
  return (
    new Intl.DateTimeFormat(undefined, { timeZoneName: "short" })
      .formatToParts(date)
      .find((part) => part.type === "timeZoneName")?.value ?? ""
  );
}

export function formatUtcTimestampWithLocal(iso: string | undefined): string {
  const utc = formatUtcTimestamp(iso);
  if (!iso || !utc || utc === iso) {
    return utc;
  }
  const local = dayjs(iso);
  if (!local.isValid()) {
    return utc;
  }
  const tz = localTimeZoneAbbreviation(local.toDate());
  const localTime = local.format("h:mm A");
  const utcDate = dayjs(iso).utc().format("YYYY-MM-DD");
  const localDate = local.format("YYYY-MM-DD");
  const localClock =
    localDate === utcDate ? localTime : `${local.format("MMM D")}, ${localTime}`;
  const localLabel = tz ? `${localClock} ${tz}` : localClock;
  return `${utc} UTC (${localLabel})`;
}
